module.exports = __webpack_public_path__ + "f1fe9e0b7e586179e6afc6edf5f0bd76.fbx";